// src/components/Auth/UserProfile.jsx  
import React, { useCallback } from 'react';    
import { User, LogOut, Settings } from 'lucide-react';

const UserProfile = React.memo(({ user, signOut, businessData, onSettingsClick }) => {
  // Memoize the settings click handler
  const handleSettingsClick = useCallback(() => {
    onSettingsClick();
  }, [onSettingsClick]);

  // Memoize the sign out handler with validation
  const handleSignOut = useCallback(() => {
    if (typeof signOut === 'function') {
      signOut();
    } else {
      console.error('signOut is not a function', signOut);
      alert('Could not sign out. Please try again.');
    }
  }, [signOut]);

  return (    
    <div className="bg-white shadow-lg rounded-lg p-4 w-auto min-w-72 max-w-96 border border-gray-200">    
      <div className="flex items-center space-x-3 border-b border-gray-200 pb-3 mb-3">    
        <div className="bg-sws-purple bg-opacity-20 rounded-full p-2 flex-shrink-0">    
          <User size={24} className="text-sws-navy" />    
        </div>    
        <div className="flex-1 min-w-0"> {/* min-w-0 allows text truncation */}
          {businessData?.firstName && (
            <p className="font-medium text-sws-navy truncate">
              {businessData.firstName} {businessData.lastName}
            </p>
          )}    
          <p className="text-xs text-sws-slate break-all">{user.email}</p> {/* Reduced from text-sm to text-xs and added break-all */}   
          <p className="text-xs text-sws-slate">User Account</p>    
        </div>    
      </div>    
          
      <div className="space-y-2">    
        <button     
          className="w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 flex items-center text-gray-700"    
          onClick={handleSettingsClick}    
        >    
          <Settings size={18} className="mr-2 text-sws-purple flex-shrink-0" />    
          <span>Account Settings</span>    
        </button>    
            
        <button     
          className="w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 flex items-center text-gray-700"    
          onClick={handleSignOut}    
        >    
          <LogOut size={18} className="mr-2 text-sws-purple flex-shrink-0" />    
          <span>Sign Out</span>    
        </button>    
      </div>    
    </div>    
  );    
});

UserProfile.displayName = 'UserProfile';

export default UserProfile;